module.exports = __webpack_public_path__ + "img/1.8f32b8f5.jpg";